var tw_callbacks_for_elements_added;
tw_callbacks_for_elements_added = [];

function twParsedUrl(url) {
    var parser = document.createElement("a");
    parser.href = url;
    parser.href = parser.href;
    if (parser.host === "") {
        var newProtocolAndHost = window.location.protocol + "//" + window.location.host;
        if (url.charAt(1) === "/") {
            parser.href = newProtocolAndHost + url;
        } else {
            var currentFolder = ("/" + parser.pathname).match(/.*\//)[0];
            parser.href = newProtocolAndHost + currentFolder + url;
        }
    }
    var properties = ['host', 'hostname', 'hash', 'href', 'port', 'protocol', 'search'];
    for (var i = 0, n = properties.length; i < n; i++) {
        this[properties[i]] = parser[properties[i]];
    }
    this.pathname = (parser.pathname.charAt(0) !== "/" ? "/" : "") + parser.pathname;
}

function twActivateTab(e) {
    var tabLinkHash = new twParsedUrl(e.target.href).hash;
    var tabLinkTab = document.querySelector(tabLinkHash);
    if (tabLinkTab) {
        this.parentElement.parentElement.querySelectorAll('li.tw-active-tab').forEach(function(tabLinkListItem) {
            /*if (tabLinkListItem.twHasProperty('tabsElement')) {
                tabLinkListItem.twSetProperty('lastScrollTop', tabLinkListItem.twGetProperty('tabsElement').scrollTop);
            }*/
            tabLinkListItem.classList.remove('tw-active-tab');
        });
        this.parentElement.classList.add('tw-active-tab');
        tabLinkTab.open = true;
        tabLinkTab.parentElement.querySelectorAll('.tw-tab[open]:not(' + tabLinkHash + ')').forEach(function(openTab) {
            openTab.open = false;
        });
        /*if (this.parentElement.twHasProperty('tabsElement') && this.parentElement.twHasProperty('lastScrollTop')) {
            this.parentElement.twGetProperty('tabsElement').scrollTop = this.parentElement.twGetProperty('lastScrollTop');
        }*/
    }
    e.preventDefault();
}
function twSetupTabs() {
    var allTabs = document.querySelectorAll('.tw-tabs');
    allTabs.forEach(function(tabsElement) {
        //twGetID(tabsElement);
        var tabsList = tabsElement.querySelector('.tw-tabs-list');
        var tabs = tabsElement.querySelectorAll('.tw-tab');
        tabsList.querySelectorAll('li > a[href^="#"]').forEach(function(tabLink) {
            //tabLink.parentElement.twSetProperty('tabsElement', tabsElement);
            //tabLink.twAddEventListener('click', twActivateTab);
            tabLink.addEventListener('click', twActivateTab);
        });
    });
}

function tw_open_paypro_popup(e) {
  e.preventDefault();
  
  var tw_paypro_popup = document.createElement('aside');
  tw_paypro_popup.classList.add('tw-paypro-popup');

  var tw_paypro_popup_iframe = document.createElement('iframe');
  tw_paypro_popup_iframe.src = this.href;
  tw_paypro_popup.appendChild(tw_paypro_popup_iframe);

  var tw_paypro_popup_close_button = document.createElement('button');
  tw_paypro_popup_close_button.classList.add('tw-paypro-popup-close');
  tw_paypro_popup_close_button.innerHTML = '<span class="display--hidden">Sluiten</span>';
  tw_paypro_popup.appendChild(tw_paypro_popup_close_button);

  if(this.nextSibling) {
    this.parentElement.insertBefore(tw_paypro_popup, this.nextSibling);
  } else {
    this.parentElement.appendChild(tw_paypro_popup);
  }
  
}
function tw_add_event_listener_to_paypro_popup_openers(tw_paypro_popup_opener) {
  tw_paypro_popup_opener.addEventListener('click', tw_open_paypro_popup);
}
tw_callbacks_for_elements_added['.tw-paypro-popup-open'] = tw_add_event_listener_to_paypro_popup_openers;

function tw_close_paypro_popup(e) {
  e.preventDefault();
  var tw_paypro_popup = this.parentElement;
  tw_paypro_popup.remove();
}
function tw_add_event_listener_to_paypro_popup_closers(tw_paypro_popup_closer) {
  tw_paypro_popup_closer.addEventListener('click', tw_close_paypro_popup);
}
tw_callbacks_for_elements_added['.tw-paypro-popup-close'] = tw_add_event_listener_to_paypro_popup_closers;

//////////////////////////////////////////
function tw_callback_for_mutation_observer_for_new_elements_in_body(tw_mutations) {
  tw_mutations.forEach(function(tw_mutation) {
    tw_mutation.addedNodes.forEach(function(tw_added_node) {
      if(tw_added_node.nodeType === 1) {
        for(tw_element_match in tw_callbacks_for_elements_added) {
          if(tw_added_node.matches(tw_element_match)) {
            tw_callbacks_for_elements_added[tw_element_match](tw_added_node);
          } else {
            var tw_element_in_element = tw_added_node.querySelectorAll(tw_element_match).forEach(tw_callbacks_for_elements_added[tw_element_match]);
            if(tw_element_in_element) {
              tw_callbacks_for_elements_added[tw_element_match](tw_element_in_element);
            }
          }
        }
      }
    });
  });
}





window.addEventListener('DOMContentLoaded', function() {
  var tw_callback_selector, tw_callback_function;
  for(tw_callback_selector in tw_callbacks_for_elements_added) {
    tw_callback_function = tw_callbacks_for_elements_added[tw_callback_selector];
    document.querySelectorAll(tw_callback_selector).forEach(tw_callback_function);
  }
  
  var tw_mutation_observer_for_new_elements_in_body;
  tw_mutation_observer_for_new_elements_in_body = new MutationObserver(tw_callback_for_mutation_observer_for_new_elements_in_body);
  tw_mutation_observer_for_new_elements_in_body.observe(document.body, {childList: true, subtree: true});
  
  twSetupTabs();
});
